var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentBigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 35,
    viewBox: "0 0 41 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1562 2.5C10.4688 2.5 2.65625 8.67188 2.65625 16.25C2.65625 19.2188 3.82812 22.0312 6.09375 24.4531C6.71875 25.2344 6.95312 26.1719 6.5625 27.0312C5.70312 29.2969 4.29688 31.3281 3.35938 32.5C6.875 32.1094 9.6875 30.625 11.4062 29.375C12.0312 28.9062 12.8906 28.8281 13.5938 29.0625C15.7031 29.6875 17.8906 30 20.1562 30C29.7656 30 37.5781 23.8281 37.5781 16.25C37.5781 8.67188 29.7656 2.5 20.1562 2.5ZM20.1562 0C31.1719 0 40.0781 7.34375 40.0781 16.25C40.0781 25.2344 31.1719 32.5 20.1562 32.5C17.5781 32.5 15.1562 32.1094 12.8906 31.4062C10.5469 33.0469 6.79688 35 2.03125 35C1.25 35 0.546875 34.6094 0.234375 33.9062C0 33.2031 0.078125 32.4219 0.625 31.875C0.703125 31.875 3.125 29.2188 4.21875 26.1719C1.64062 23.4375 0.15625 20 0.15625 16.25C0.15625 7.34375 9.0625 0 20.1562 0Z",
    fill: "#FF8853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBigIcon);
export default __webpack_public_path__ + "static/media/commentBigIcon.c6191d8e36d7119a67ebbefea59a9f7e.svg";
export { ForwardRef as ReactComponent };